<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      isRouterAlive: true
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(_ => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="less">
  @import './style/common.less';
  .tableContent{
    padding: 20px !important;
    background: #ffffff;
    margin-top: 20px;
  }
  body .el-table th.gutter{
    display: table-cell!important;
  }
  body .el-table colgroup.gutter{
    display: table-cell!important;
  }
  .selectWx {
    .el-scrollbar__wrap {
      overflow: hidden;
      overflow-y: scroll;
      padding-bottom: 12px;
      height: 340px;
    }
    .is-horizontal {
      display: none;
    }
  }
</style>
